/* Cledro v2 (redesign, Nov 2026): header menus and search, the wishlist hearts and card swatches. The pages add their own small scripts. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var EN = (document.documentElement.lang || '').indexOf('en') === 0;

  /* page scroll lock while a menu or the search is open (counts, so overlays can stack) */
  var locks = 0, lastFocus = null;
  function lock(on) { locks = Math.max(0, locks + (on ? 1 : -1)); document.body.classList.toggle('locked', locks > 0); }
  window.CLV2 = window.CLV2 || {};
  window.CLV2.lock = lock;
  window.CLV2.en = EN;

  /* wishlist: the hearts use the shop's own wishlist (snippets/wishlist-icon): localStorage wishlist_<handle> = 'true',
     the same keys the header heart and the wishlist drawer read */
  var W_ADD = EN ? 'Add to wishlist' : 'Toevoegen aan verlanglijst', W_DEL = EN ? 'Remove from wishlist' : 'Verwijderen uit verlanglijst';
  function saved(h) { try { return localStorage.getItem('wishlist_' + h) === 'true'; } catch (e) { return false; } }
  function paintWish(b) {
    var on = saved(b.getAttribute('data-product-id'));
    b.classList.toggle('wishlisted', on);
    b.setAttribute('aria-pressed', String(on));
    b.setAttribute('aria-label', on ? W_DEL : W_ADD);
  }
  function wishCount() {
    var n = 0;
    try { for (var i = 0; i < localStorage.length; i++) { var k = localStorage.key(i); if (k && k.indexOf('wishlist_') === 0 && localStorage.getItem(k) === 'true') n++; } } catch (e) {}
    $$('[data-wish-count]').forEach(function (el) { el.textContent = n ? String(n) : ''; el.hidden = !n; });
  }
  function wishSync(root) { $$('.cl-wish[data-product-id]', root).forEach(paintWish); wishCount(); }
  window.CLV2.wishSync = wishSync;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.cl-wish[data-product-id]');
    if (b) {
      e.preventDefault();
      var h = b.getAttribute('data-product-id'), on = !saved(h);
      try { localStorage.setItem('wishlist_' + h, on ? 'true' : 'false'); } catch (err) {}
      $$('.cl-wish').forEach(function (x) { if (x.getAttribute('data-product-id') === h) paintWish(x); });
      wishCount();
      return;
    }
    var o = e.target.closest && e.target.closest('[data-wish-open]');
    if (o) {
      e.preventDefault();
      if (window.CLV2.closeMenu) window.CLV2.closeMenu();
      setTimeout(function () {
        if (window.CledroWishlist && window.CledroWishlist.open) window.CledroWishlist.open();
        else { var hb = document.getElementById('wishlist-header-btn'); if (hb) hb.click(); }
      }, 260);
      return;
    }
    /* "remove" inside the drawer only changes the drawer's own buttons; repaint ours */
    if (e.target.closest && e.target.closest('#wishlist-drawer')) setTimeout(function () { wishSync(); }, 40);
  });
  window.addEventListener('storage', function () { wishSync(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { wishSync(); });
  else wishSync();

  /* model cards outside the glasses pages (similar frames on a product page, the homepage bestsellers): the swatch
     carries its colour's link, photos and stock, so the card can switch colour without the shop data */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    var sw = e.target.closest && e.target.closest('[data-card] [data-sw][data-u]');
    if (!sw) return;
    e.preventDefault();
    var c = sw.closest('[data-card]'), h = sw.getAttribute('data-sw'), u = sw.getAttribute('data-u');
    var name = c.getAttribute('data-card') || '', col = sw.getAttribute('data-c') || '';
    $$('[data-go]', c).forEach(function (a) { a.setAttribute('data-go', h); a.setAttribute('href', u); });
    var a = $('img[data-img="0"]', c), b = $('img[data-img="1"]', c);
    if (a) { a.removeAttribute('srcset'); a.src = sw.getAttribute('data-i0'); a.alt = name + ' in ' + col.toLowerCase(); a.classList.toggle('cl-cut', sw.getAttribute('data-k') === '1'); }
    if (b) {
      if (b.getAttribute('src')) { b.classList.remove('ld'); b.onload = function () { b.classList.add('ld'); }; b.src = sw.getAttribute('data-i1'); }
      else b.setAttribute('data-src', sw.getAttribute('data-i1'));
    }
    $$('.cname', c).forEach(function (x) { x.textContent = col; });
    $$('a[data-go][aria-label]', c).forEach(function (x) { x.setAttribute('aria-label', name + ', ' + col); });
    $$('[data-sw]', c).forEach(function (s) { s.setAttribute('aria-pressed', String(s === sw)); });
    var so = $('.tag.so', c), avail = sw.getAttribute('data-a') !== '0';
    if (!avail && !so) { var t = document.createElement('span'); t.className = 'tag so'; t.textContent = EN ? 'Sold out' : 'Uitverkocht'; ($('.pcard-ph', c) || $('.h-prod-ph', c) || c).appendChild(t); }
    if (avail && so) so.remove();
    $$('.cl-wish', c).forEach(function (w) { w.setAttribute('data-product-id', h); });
    wishSync(c);
  });
  /* the worn photo loads on the first hover */
  document.addEventListener('pointerover', function (e) {
    var ph = e.target.closest && e.target.closest('.pcard-ph');
    if (!ph) return;
    var b = $('.b', ph);
    if (b && !b.getAttribute('src') && b.getAttribute('data-src')) { b.onload = function () { b.classList.add('ld'); }; b.src = b.getAttribute('data-src'); }
  }, { passive: true });

  var hdr = $('#clHdr');
  if (!hdr) return;

  /* Brillen mega menu: hover on desktop, tap anywhere */
  var mega = $('#clMega'), megaBtn = $('#clMegaBtn'), megaOpen = false, megaTimer = null;
  function setMega(on) { megaOpen = on; mega.hidden = !on; megaBtn.setAttribute('aria-expanded', String(on)); }
  function closeMega() { clearTimeout(megaTimer); if (megaOpen) setMega(false); }
  var hoverAt = 0;
  megaBtn.addEventListener('click', function () {
    if (megaOpen && Date.now() - hoverAt < 600) return; /* the hover just opened it; a click right after should not close it */
    setMega(!megaOpen);
  });
  if (window.matchMedia('(hover: hover)').matches) {
    megaBtn.addEventListener('mouseenter', function () { clearTimeout(megaTimer); if (!megaOpen) hoverAt = Date.now(); setMega(true); });
    hdr.addEventListener('mouseleave', function () { megaTimer = setTimeout(function () { setMega(false); }, 200); });
    hdr.addEventListener('mouseenter', function () { clearTimeout(megaTimer); });
    $$('.hdr-nav a', hdr).forEach(function (a) { a.addEventListener('mouseenter', closeMega); });
  }
  document.addEventListener('click', function (e) { if (megaOpen && !hdr.contains(e.target)) closeMega(); });

  /* mobile menu */
  var mm = $('#clMenu'), burger = $('#clBurger');
  function openMenu(on) {
    if (!mm || mm.classList.contains('open') === on) return;
    mm.classList.toggle('open', on); mm.setAttribute('aria-hidden', String(!on));
    burger.setAttribute('aria-expanded', String(on)); lock(on);
    if (on) { lastFocus = document.activeElement; setTimeout(function () { $('#clMenuClose').focus(); }, 40); }
    else if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.CLV2.closeMenu = function () { openMenu(false); };
  burger.addEventListener('click', function () { openMenu(true); });
  $('#clMenuClose').addEventListener('click', function () { openMenu(false); });

  /* search: Shopify's predictive search, shown as small frame cards like the rest of the shop */
  var search = $('#clSearch'), sIn = $('#clSearchIn'), grid = $('#clSearchGrid'), none = $('#clSearchNone'), count = $('#clSearchCount');
  var popular = grid.innerHTML, ctl = null, timer = null;
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function openSearch(on) {
    if (search.classList.contains('open') === on) return;
    search.classList.toggle('open', on); search.setAttribute('aria-hidden', String(!on)); lock(on);
    if (on) { lastFocus = document.activeElement; sIn.value = ''; draw(''); setTimeout(function () { sIn.focus(); }, 60); }
    else if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function show(items, q) {
    if (!q) { count.textContent = EN ? 'Popular' : 'Populair'; grid.innerHTML = popular; grid.hidden = false; none.hidden = true; return; }
    var frames = items.filter(function (p) { return !/brillenset|glasses set/i.test(p.title); });
    var n = frames.length;
    count.textContent = n + ' ' + (EN ? (n === 1 ? 'result' : 'results') : (n === 1 ? 'resultaat' : 'resultaten'));
    if (!n) {
      grid.hidden = true; none.hidden = false;
      none.textContent = EN ? 'Nothing found for “' + q + '”. Try a colour such as “green” or a shape such as “round”.'
        : 'Niets gevonden voor “' + q + '”. Probeer een kleur zoals “groen” of een vorm zoals “rond”.';
      return;
    }
    grid.hidden = false; none.hidden = true;
    grid.innerHTML = frames.slice(0, 12).map(function (p) {
      var t = String(p.title || ''), m = t.split(' ')[0], c = t.slice(m.length).trim();
      var img = p.image ? p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
      var cut = img && window.CLV2CUT ? window.CLV2CUT(img) : null;  /* the frame without its white background */
      if (cut) img = cut;
      return '<a class="mini" href="' + esc(p.url) + '"><div class="ph">' + (img ? '<img' + (cut ? ' class="cl-cut"' : '') + ' src="' + esc(img) + '" alt="" loading="lazy">' : '') +
        '</div><b>' + esc(m) + '</b><span>' + esc(c) + '</span></a>';
    }).join('');
  }
  function draw(q) {
    q = q.trim();
    clearTimeout(timer);
    if (!q) { show([], ''); return; }
    timer = setTimeout(function () {
      if (ctl) ctl.abort();
      ctl = 'AbortController' in window ? new AbortController() : null;
      var url = search.getAttribute('data-url') + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';
      fetch(url, ctl ? { signal: ctl.signal } : {}).then(function (r) { return r.json(); }).then(function (d) {
        var items = (d && d.resources && d.resources.results && d.resources.results.products) || [];
        show(items, q);
      }).catch(function () {});
    }, 160);
  }
  $('#clSearchBtn').addEventListener('click', function () { closeMega(); openSearch(true); });
  $('#clSearchClose').addEventListener('click', function () { openSearch(false); });
  sIn.addEventListener('input', function () { draw(sIn.value); });
  sIn.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && sIn.value.trim()) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.location.href = root + 'search?q=' + encodeURIComponent(sIn.value.trim()) + '&type=product';
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeMega(); openMenu(false); openSearch(false);
  });
})();
